module.exports = __webpack_public_path__ + "img/em-tao-process-02.daab154b.webp";